import {getShopId} from "../components/lib/getShopId";
import {WarehouseFactory} from "@connox/typescript-library";
import {BrowserStorage} from "../storage/BrowserStorage";

const utilizationMessageStorage = new BrowserStorage<string>({
  type: "sessionStorage",
  dataIdentifier: "utilizationMessage",
  hoursToCache: 1,
});

export const getUtilizationMessage = async (): Promise<string | undefined> => {
  const utilizationMessageEntry: string | null = utilizationMessageStorage.read(`${getShopId()}`);
  let utilizationMessage;

  if (utilizationMessageEntry === null) {
    utilizationMessage = await WarehouseFactory.getUtilizationMessage(getShopId());
    utilizationMessageStorage.write(getShopId(), utilizationMessage ?? "undefined");
  } else if (utilizationMessageEntry === "undefined") {
    utilizationMessage = undefined;
  } else {
    utilizationMessage = utilizationMessageEntry;
  }

  return utilizationMessage as string | undefined;
};
